import React from 'react';
import VAPublicProfileSettings from '../../../components/profiles/VAPublicProfileSettings';

const VisibilityTab = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-gray-800">Profile Visibility</h2>
      <p className="text-gray-600">
        Control how your profile appears to others and manage your public profile settings.
      </p>
      
      <VAPublicProfileSettings />
      
    </div>
  );
};

export default VisibilityTab;

